import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Lock, Mail, LogIn } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { Logo } from "../../components/Logo";

export default function AdminLogin() {
  const { login, user } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => { if (user) navigate("/admin"); }, [user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      navigate("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Invalid email or password");
    } finally { setLoading(false); }
  };

  const inputCls = "w-full rounded-xl border border-slate-200 pl-11 pr-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-[#1A75BC]/40 focus:border-[#1A75BC]";

  return (
    <div className="min-h-screen gradient-bg-soft grid-pattern flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl shadow-xl w-full max-w-md p-8">
        <div className="flex justify-center mb-6"><Logo className="h-12 w-12" /></div>
        <h1 className="text-2xl font-extrabold text-[#0F1E36] text-center">Admin Dashboard</h1>
        <p className="text-sm text-[#627D98] text-center mt-1 mb-8">Sign in to manage your clinic website</p>
        <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
          <div className="relative"><Mail size={18} className="absolute left-3.5 top-3.5 text-slate-400" /><input className={inputCls} type="email" placeholder="Email address" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" /></div>
          <div className="relative"><Lock size={18} className="absolute left-3.5 top-3.5 text-slate-400" /><input className={inputCls} type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" /></div>
          <button type="submit" disabled={loading} className="w-full gradient-bg btn-glow text-white font-bold py-3.5 rounded-full flex items-center justify-center gap-2 disabled:opacity-60" data-testid="login-submit">
            <LogIn size={18} /> {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
